export class ListOrganizationIdpGroupsResponse {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "groups",
            "baseName": "groups",
            "type": "Array<OrganizationIdpGroup>",
            "format": ""
        },
        {
            "name": "totalCount",
            "baseName": "totalCount",
            "type": "number",
            "format": ""
        },
        {
            "name": "nextToken",
            "baseName": "nextToken",
            "type": "string",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return ListOrganizationIdpGroupsResponse.attributeTypeMap;
    }
    constructor() {
    }
}
